// The accountId claim that firestore.rules and the data callables read
// (SPEC-14). Firebase Auth creates a user without it; setupAccount in the
// functions repo sets it, and the ID token is refreshed to carry it. Sign-up
// calls this after creating the user, sign-in after any sign-in that finds
// it missing (a new Google account, a sign-up cut short).

import type { FirebaseApp } from "firebase/app";
import type { User } from "firebase/auth";

import { FUNCTIONS_REGION } from "../data/transport";

/** Sets the claim when the token lacks it. Resolves true when it was missing. */
export async function ensureAccountClaim(app: FirebaseApp, user: User): Promise<boolean> {
  if (typeof (await user.getIdTokenResult()).claims["accountId"] === "string") return false;
  const { getFunctions, httpsCallable } = await import("firebase/functions");
  await httpsCallable(getFunctions(app, FUNCTIONS_REGION), "setupAccount")({});
  await user.getIdToken(true);
  return true;
}
